import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#0f172a] border-t border-white/10 py-8" data-id="element-54">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-55">
          <p className="text-sm text-gray-500" data-id="element-56">
            © {new Date().getFullYear()} Protocolo Adiós Insomnio. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-57">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-[#d4a853] transition-colors" data-id="element-58">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-[#d4a853] transition-colors" data-id="element-59">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-60">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={() => setActiveModal(null)} data-id="element-61">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-62">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-63">
                <h2 className="text-2xl text-[#0f172a]" data-id="element-64">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-65">
                  <XIcon className="w-5 h-5 text-gray-500" data-id="element-66" />
                </button>
              </div>

              <div className="px-6 py-6 text-gray-700 leading-relaxed space-y-4" data-id="element-67">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-68" /> : <TermsContent data-id="element-69" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-70">Última actualización: Abril 2026</p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-71">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-72">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital, incluyendo tu nombre y dirección de
        correo electrónico.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-73">
        2. Uso de la Información
      </h3>
      <p data-id="element-74">
        Tu información personal se utiliza exclusivamente para: procesar tu
        pedido, enviarte el acceso a tu producto digital y comunicarte
        actualizaciones relacionadas con tu compra.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-75">
        3. Protección de Datos
      </h3>
      <p data-id="element-76">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. No almacenamos datos de tarjetas de
        crédito; todos los pagos son procesados por plataformas de pago seguras
        de terceros.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-77">
        4. Compartir Información
      </h3>
      <p data-id="element-78">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de
        confianza que nos ayudan a operar nuestro sitio web y procesar pagos.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-79">5. Cookies</h3>
      <p data-id="element-80">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades del sitio.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-81">6. Tus Derechos</h3>
      <p data-id="element-82">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los canales disponibles en nuestro sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-83">Última actualización: Abril 2026</p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-84">
        1. Producto Digital
      </h3>
      <p data-id="element-85">
        "Protocolo Adiós Insomnio" es un producto digital informativo en formato
        PDF. Al completar tu compra, recibirás acceso inmediato para descargar
        el material.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-86">2. Uso Personal</h3>
      <p data-id="element-87">
        El contenido adquirido es para uso personal y no comercial. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización expresa por escrito.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-88">
        3. Descargo de Responsabilidad
      </h3>
      <p data-id="element-89">
        El contenido de esta guía es informativo y educativo. No sustituye el
        consejo médico profesional. Consulta siempre con tu médico antes de
        realizar cambios significativos en tu rutina de salud, especialmente si
        estás bajo tratamiento médico.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-90">4. Resultados</h3>
      <p data-id="element-91">
        Los resultados pueden variar de persona a persona. Los testimonios y
        estadísticas presentados representan experiencias individuales y no
        garantizan resultados específicos.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-92">
        5. Política de Reembolso
      </h3>
      <p data-id="element-93">
        Debido a la naturaleza digital del producto y el acceso inmediato
        proporcionado, todas las ventas son finales. Te recomendamos revisar
        toda la información disponible en esta página antes de realizar tu
        compra.
      </p>

      <h3 className="text-xl font-semibold text-[#0f172a]" data-id="element-94">
        6. Modificaciones
      </h3>
      <p data-id="element-95">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio.
      </p>
    </>;
}